<template>
  <div class="wrapper">
    <ButtonBase round class="share-button" @click="share()">
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        xmlns="http://www.w3.org/2000/svg"
        class="share-button__icon icon"
      >
        <path
          d="M3.16602 8V11.3333C3.16602 11.8638 3.37673 12.3725 3.7518 12.7475C4.12687 13.1226 4.63558 13.3333 5.16602 13.3333H11.8327C12.3631 13.3333 12.8718 13.1226 13.2469 12.7475C13.622 12.3725 13.8327 11.8638 13.8327 11.3333V8"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M5.83268 4.66667L8.49935 2M8.49935 2L11.166 4.66667M8.49935 2L8.49935 10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
      SHARE
    </ButtonBase>

    <div v-if="modalIsOpen" class="modal">
      <button class="modal-background" tabindex="-1" @click="modalIsOpen = false"></button>

      <div class="modal-card">
        <div class="modal-card-header relative">
          <h2 class="modal-card-header__title">Share</h2>
          <button class="modal-card-header__close-icon" @click="modalIsOpen = false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 12 12"
              class="icon"
              aria-label="Cancel share"
            >
              <title>cross-L</title>
              <path
                d="M7.42,6l4.29,4.29a1,1,0,0,1-1.42,1.42L6,7.42,1.71,11.71A1,1,0,0,1,.29,10.29L4.58,6,.29,1.71A1,1,0,0,1,1.71.29L6,4.58,10.29.29a1,1,0,1,1,1.42,1.42Z"
              ></path>
            </svg>
          </button>
        </div>

        <div class="modal-card-content">
          <ul class="ml-10 space-y-16">
            <li>
              <a :href="facebookUrl" target="_blank">
                <svg
                  id="Layer_2"
                  data-name="Layer 2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 42.73 42.73"
                  class="icon"
                >
                  <g id="Layer_1-2" data-name="Layer 1">
                    <g>
                      <path
                        d="m22.86,2.54c0-1.4-1.14-2.54-2.54-2.54-5.46,0-10.02,3.93-11,9.13l-.14.91c-.04.39-.06.79-.06,1.19v5.91s-6.57,0-6.57,0c-1.41,0-2.54,1.14-2.54,2.54s1.14,2.54,2.54,2.54h6.59l.02,14.91c0,1.4,1.14,2.54,2.54,2.54s2.54-1.14,2.54-2.54V14.49l-.03-3.28c0-.73.15-1.42.39-2.08.85-2.35,3.09-4.04,5.73-4.04,1.4,0,2.54-1.14,2.54-2.54"
                      ></path>
                      <path
                        d="m22.18,17.14h-2.45c-1.4,0-2.54,1.14-2.54,2.54s1.14,2.54,2.54,2.54h2.45c1.4,0,2.54-1.14,2.54-2.54s-1.14-2.54-2.54-2.54"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Share to Facebook</span>
              </a>
            </li>
            <li>
              <a :href="twitterUrl" target="_blank">
                <svg
                  id="Layer_2"
                  data-name="Layer 2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 45 45"
                  class="icon"
                >
                  <g id="Layer_1-2" data-name="Layer 1">
                    <g>
                      <path
                        d="m27.67,39.69c-.81,0-1.61-.37-2.12-1.08L.5,4.15C-.35,2.98-.09,1.36,1.07.5,2.25-.35,3.87-.09,4.72,1.09l25.06,34.46c.84,1.16.59,2.8-.57,3.65-.46.33-1,.49-1.53.49"
                      ></path>
                      <path
                        d="m20.09,15.9c-.53,0-1.05-.16-1.51-.48-1.18-.83-1.45-2.47-.62-3.65L25.56,1.1c.83-1.18,2.47-1.45,3.63-.62,1.18.83,1.45,2.47.62,3.65l-7.58,10.67c-.51.72-1.31,1.1-2.13,1.1"
                      ></path>
                      <path
                        d="m2.62,39.69c-.53,0-1.07-.16-1.53-.49-1.16-.84-1.42-2.49-.57-3.65l7.73-10.61c.85-1.16,2.49-1.42,3.65-.57,1.16.84,1.42,2.48.57,3.65l-7.73,10.61c-.51.7-1.31,1.07-2.12,1.07"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Share to Twitter</span>
              </a>
            </li>
            <li>
              <a :href="linkedinUrl" target="_blank">
                <svg
                  id="Layer_2"
                  data-name="Layer 2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 45 45"
                  class="icon"
                >
                  <g id="Layer_1-2" data-name="Layer 1">
                    <g>
                      <path
                        d="m23.71,12.69h0c-1.39,0-2.51,1.14-2.51,2.54s1.13,2.54,2.51,2.54c3.99,0,7.23,3.28,7.23,7.3v12.07c0,1.4,1.12,2.54,2.51,2.54s2.51-1.14,2.51-2.54v-12.07c0-6.83-5.5-12.39-12.25-12.39"
                      ></path>
                      <path
                        d="m1.55,4.9h0c.31.13.62.2.97.2.67,0,1.31-.27,1.78-.74.48-.49.74-1.14.74-1.81,0-.16-.01-.33-.04-.49-.03-.17-.08-.33-.14-.49-.07-.14-.14-.3-.24-.43-.08-.15-.19-.28-.31-.39-.12-.12-.24-.23-.38-.32-.13-.1-.28-.17-.43-.23-.15-.06-.31-.12-.47-.16C2.68-.01,2.35-.01,2.02.04c-.16.04-.32.09-.47.16-.15.06-.3.13-.43.23-.14.09-.27.2-.38.32-.12.11-.23.24-.32.39-.1.13-.17.29-.24.43-.06.16-.11.31-.14.49-.03.16-.04.32-.04.49C0,3.22.26,3.86.74,4.35c.23.23.51.42.81.54"
                      ></path>
                      <path
                        d="m2.52,11.75c-1.39,0-2.52,1.14-2.52,2.54v22.85c0,1.41,1.13,2.54,2.52,2.54s2.51-1.14,2.51-2.54V14.29c0-1.4-1.13-2.54-2.51-2.54"
                      ></path>
                      <path
                        d="m16.13,12.42c-1.39,0-2.52,1.14-2.52,2.54v22.18c0,1.4,1.12,2.54,2.52,2.54s2.51-1.14,2.51-2.54V14.96c0-1.4-1.12-2.54-2.51-2.54"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Share to LinkedIn</span>
              </a>
            </li>
            <li>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.4776 3.45288C14.4206 2.54209 15.6836 2.03811 16.9946 2.04951C18.3056 2.0609 19.5597 2.58674 20.4867 3.51378C21.4137 4.44082 21.9396 5.69489 21.951 7.00587C21.9624 8.31685 21.4584 9.57987 20.5476 10.5229L20.5354 10.5353L16.5354 14.5353C15.5978 15.4726 14.3261 15.9993 13.0003 15.9993C11.6745 15.9993 10.403 15.4727 9.46532 14.5354C9.07474 14.1449 9.07465 13.5117 9.46511 13.1212C9.85558 12.7306 10.4887 12.7305 10.8793 13.121C11.4419 13.6834 12.2048 13.9993 13.0003 13.9993C13.7958 13.9993 14.5586 13.6834 15.1212 13.1211C15.1213 13.121 15.1212 13.1211 15.1212 13.1211L19.1147 9.12762C19.6576 8.56244 19.9579 7.80714 19.9511 7.02325C19.9442 6.23666 19.6287 5.48422 19.0725 4.928C18.5163 4.37177 17.7638 4.05627 16.9772 4.04943C16.1933 4.04262 15.438 4.34291 14.8728 4.88585L13.7794 5.97927C13.3889 6.36979 12.7557 6.36979 12.3652 5.97927C11.9747 5.58875 11.9747 4.95558 12.3652 4.56506L13.4652 3.46506L13.4776 3.45288ZM7.46532 9.46495C8.40296 8.5276 9.6745 8.00102 11.0003 8.00102C12.3261 8.00102 13.5977 8.5276 14.5353 9.46495C14.9259 9.85542 14.926 10.4886 14.5355 10.8792C14.1451 11.2697 13.5119 11.2698 13.1213 10.8794C12.5587 10.317 11.7958 10.001 11.0003 10.001C10.2049 10.001 9.442 10.3169 8.87943 10.8793C8.8794 10.8793 8.87947 10.8792 8.87943 10.8793L4.87943 14.8793L4.86704 14.8915C4.58051 15.1682 4.35196 15.4992 4.19473 15.8652C4.03751 16.2313 3.95475 16.6249 3.95129 17.0232C3.94782 17.4216 4.02373 17.8166 4.17457 18.1853C4.32541 18.554 4.54817 18.889 4.82985 19.1706C5.11153 19.4523 5.44649 19.6751 5.81517 19.8259C6.18386 19.9768 6.5789 20.0527 6.97724 20.0492C7.37558 20.0457 7.76924 19.963 8.13525 19.8058C8.50126 19.6485 8.8323 19.42 9.10904 19.1335L9.12154 19.1207L10.2235 18.0197C10.6142 17.6294 11.2474 17.6297 11.6378 18.0204C12.0281 18.4111 12.0278 19.0442 11.6371 19.4346L10.5411 20.5296C10.0812 21.004 9.53177 21.3826 8.92464 21.6434C8.31462 21.9054 7.65852 22.0434 6.99462 22.0491C6.33072 22.0549 5.67233 21.9284 5.05784 21.677C4.44336 21.4256 3.8851 21.0543 3.41564 20.5849C2.94617 20.1154 2.57491 19.5571 2.3235 18.9426C2.0721 18.3282 1.94559 17.6698 1.95136 17.0059C1.95713 16.342 2.09506 15.6859 2.35711 15.0759C2.61794 14.4686 2.99655 13.9192 3.47102 13.4593L7.46532 9.46495Z"
                ></path>
              </svg>
              <button v-if="!urlCopied" data-test="copy-link" @click="copyUrl()">
                <span>Copy Link</span>
              </button>
              <span v-else data-test="link-copied">Link copied</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonBase from '@/components/ButtonBase.vue';

export default {
  name: 'ShareButton',
  components: {
    ButtonBase,
  },
  props: {
    url: {
      type: String,
      default: () => window.location.href,
    },
  },
  data() {
    return {
      urlCopied: false,
      modalIsOpen: false,
    };
  },
  computed: {
    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.url}`;
    },
    twitterUrl() {
      return `https://twitter.com/intent/tweet?text=${this.url}`;
    },
    linkedinUrl() {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${this.url}`;
    },
  },
  methods: {
    share() {
      if (navigator.share) {
        navigator.share({
          url: this.url,
        });
      } else {
        this.modalIsOpen = true;
      }
    },
    copyUrl() {
      navigator.clipboard.writeText(this.url);
      this.urlCopied = true;
      setTimeout(() => {
        this.urlCopied = false;
      }, 1500);
    },
  },
};
</script>
